import { CallPastMessage, HistoryMessageItem, MessageIncomingEvent, MessageOutgoingEvent, ReactionAddedByOtherEvent, ReactionAddedByYouEvent, MessagePinnedByOtherEvent, MessageUnPinnedByOtherEvent } from '@wui/im'

import { DraftMessage } from '@/entities/messages'

import { Room } from '@/shared/types/store'

export enum NavState {
  CHATS = 'chat',
  CALLS = 'calls',
  CONTACTS = 'contacts',
  NOTIFICATIONS = 'notifications',
  /**
   * @deprecated
   */
  CALENDAR = 'calendar',
  CREATE_CHAT = 'createChat',
  /**
   * @deprecated
   */
  CREATE_MODERATED_CHAT = 'createModeratedChat',
  SETTINGS = 'settings',
  /**
   * @deprecated
   */
  CALLBACK_DIAL_SERVICE = 'callbackDialService',
  /**
   * @deprecated
   */
  SEND_FAX = 'sendFax',
  MAIN_MENU = 'main-menu',
}

export interface RoomListItem extends Room {
  roomId: string;
  pServedUser: string;
  name: string;
  isGroup: boolean;
  lastMessage?: HistoryMessageItem<ReactionAddedByOtherEvent | ReactionAddedByYouEvent | MessageIncomingEvent | MessageOutgoingEvent | CallPastMessage | MessagePinnedByOtherEvent | MessageUnPinnedByOtherEvent>;
  number: string;
  isExternal?: boolean;
  draft?: DraftMessage;
}

export type Events = {
  scrollStart: void;
  scrollStop: void;
  scrolledToDown: void;
  scrolledToTop: void;
  scrolledNearTop: void;
  scrolledNearBottom: void;
  /** User reached the bottom edge — cancel stale top-history prefetch. */
  userAtChatBottom: void;
}
